import {assertUnreachable} from './assert.js';

export function stringToEnum<EnumType extends Record<string, string>>(
  enumObj: EnumType,
  str: string
): EnumType[keyof EnumType] {
  let enumValue;
  if (Object.values(enumObj).includes(str)) {
    enumValue = str as EnumType[keyof EnumType];
    return enumValue;
  }

  assertUnreachable(enumValue, `${str} was not found in enum`);
}
